module.exports = __webpack_public_path__ + "img/kyrgyzstan.d35765ff.svg";